// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__ZVqVj","icon_container":"style_icon_container__hct6g","img-load":"style_img-load__oqC3Z"};